import { UserNotificationSearchResponse } from '@lio/api-types';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { NotificationKeys } from '@services/notification/keys';
export const useSearchUserNotifications = (includeDismissed: boolean, userId?: string, pageLimit?: number) => {
  const client = useClient();
  const result = useInfiniteQuery<UserNotificationSearchResponse, Error>({
    queryKey: NotificationKeys.searchUserNotifications({ pageLimit }),
    queryFn: ({ pageParam = 0 }) => {
      const paginationParams = pageLimit ? `?pageLimit=${pageLimit}&pageOffset=${pageParam}` : '';
      return client.get(`user/${userId}/notification${paginationParams}`).json<UserNotificationSearchResponse>();
    },
    initialPageParam: 0,
    enabled: !!userId,
    staleTime: 15000,
    placeholderData: (previousData) => previousData,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.pagination) return undefined;
      if (!lastPage.pagination.pageLimit) return undefined;
      if (!lastPage.pagination.total) return undefined;
      const { total, pageLimit } = lastPage.pagination;
      const fetchedPageCount = allPages.length;
      const nextPageOffsetValue = fetchedPageCount * pageLimit;
      if (nextPageOffsetValue > total) return undefined;
      return nextPageOffsetValue;
    },
  });

  return { ...result, notifications: result.data };
};
